var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGuidesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#52C0A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.792 15.475a1.008 1.008 0 00-.992 1.042.992.992 0 001.025.958h-.033c.55-.01.991-.458.991-1.008a1.016 1.016 0 00-.991-.992zM11.983 6.558a4.166 4.166 0 00-3.125 1.275.652.652 0 00-.142.417c.005.37.298.67.667.683a.703.703 0 00.467-.175 2.727 2.727 0 011.975-.833c1.125 0 1.666.608 1.666 1.325 0 1.533-2.725 1.725-2.725 3.717 0 .483.3 1.375.925 1.375h.017a.608.608 0 00.608-.609c0-.225-.158-.416-.158-.641 0-1.5 2.933-1.709 3-4.034 0-1.416-1.2-2.5-3.175-2.5z",
    fill: "#fff"
  })));
}

export default SvgGuidesIcon;